import { Action } from '@ngrx/store';
import { IProductExperienceRequest, IProductRequest } from '../../models/order-management/product.model';
import { IProduct } from '@cemex-core/cmx-api/models/product/models/product.interface';
import { ProductsResponseOP } from '@cemex-core/cmx-api';

export const OP_PRODUCT_RESET = '[openPlatform - Product] Reset state';
export const OP_PRODUCT_LOAD = '[openPlatform - Product] Load';
export const OP_PRODUCT_EXPERIENCE_LOAD = '[openPlatform - Product] Product and Experience Load';

export const OP_PRODUCT_LOAD_COMPLETE = '[openPlatform - Product] Load Complete';
export const OP_PRODUCT_LOAD_FAIL = '[openPlatform - Product] Load Fail';
export const OP_PRODUCT_ADD_ENTITY = '[openPlatform - Product] Add Entity';

export class ProductResetStateAction implements Action {
  readonly type = OP_PRODUCT_RESET;

  constructor(public payload = null) {}
}

export class ProductLoadAction implements Action {
  readonly type = OP_PRODUCT_LOAD;

  constructor(public payload: IProductRequest) {}
}

export class ProductExperienceLoadAction implements Action {
  readonly type = OP_PRODUCT_EXPERIENCE_LOAD;

  constructor(public payload: IProductExperienceRequest) {}
}

export class ProductLoadCompleteAction implements Action {
  readonly type = OP_PRODUCT_LOAD_COMPLETE;

  constructor(public payload: ProductsResponseOP) {}
}

export class ProductLoadFailAction implements Action {
  readonly type = OP_PRODUCT_LOAD_FAIL;

  // todo:: type of error handling
  constructor(public payload: any) {}
}

export class ProductAddEntityAction implements Action {
  readonly type = OP_PRODUCT_ADD_ENTITY;
  constructor(public payload: IProduct) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type ProductActions =
  | ProductLoadAction
  | ProductExperienceLoadAction
  | ProductResetStateAction
  | ProductLoadFailAction
  | ProductLoadCompleteAction
  | ProductAddEntityAction;
